import teamsSearch from 'app/modules/search/sagas/teamsSearch';

const sagaRegistry = [teamsSearch];

export default sagaRegistry;
